import { Flex, LoadingOverlay, NextProvider } from '@hover/blueprint';
import React from 'react';
import { Redirect } from 'react-router';
import { useParams } from 'react-router-dom';

import { Header } from 'src/modules/pro/components/Header';
import { useProSplit } from 'src/modules/pro/hooks/useProSplit';
import { Route as Routes } from 'src/shared/route';

const Container = ({ children }: { children: React.ReactNode }) => (
  <Flex align="center" direction="column" height="100%" width="100%">
    {children}
  </Flex>
);

export const ProPage = () => {
  const { isLoading, isProLandingPageSplitOn } = useProSplit();
  const { orgId } = useParams<{ orgId: string }>();

  if (isLoading) {
    return <LoadingOverlay color="neutral.900" isLoading />;
  }

  if (orgId && isProLandingPageSplitOn) {
    return (
      <NextProvider attach>
        <Container>
          <Header />
        </Container>
      </NextProvider>
    );
  }

  return (
    <Redirect from={Routes.PRO.path} to={Routes.HOMEOWNER_APP_HOME.path} />
  );
};
